var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useCallback } from 'react';
import { Grid, Typography } from '@mui/material';
import { TituloCardCinza } from './TituloCardCinza';
import { ShowContent } from '../../../components/ShowContent';
import { GridView } from './GridView';
import { prettyArea } from '../Cadastro/SegundaAba/DadosImovelUsucapiaoRural';
import { UfEnumOptions } from '../../../model/enums/UfEnum';
export var DadosImvConcedView = function (_a) {
    var _b, _c;
    var setActiveStep = _a.setActiveStep, tipoRequerimento = _a.tipoRequerimento, dados = _a.dados, index = _a.index;
    var dadosImv = useCallback(function () {
        var _a;
        return [
            {
                label: 'Denominação do Imóvel concedido',
                value: dados === null || dados === void 0 ? void 0 : dados.denominacao,
                fullWidth: true
            },
            {
                label: 'Matricula',
                value: dados === null || dados === void 0 ? void 0 : dados.matricula
            },
            {
                label: 'Área do Imóvel concedido (HA)',
                value: prettyArea(dados === null || dados === void 0 ? void 0 : dados.area)
            },
            {
                label: 'UF do Imóvel concedido',
                value: ((dados === null || dados === void 0 ? void 0 : dados.uf) ? UfEnumOptions.getDescricao(dados === null || dados === void 0 ? void 0 : dados.uf) : '')
            },
            {
                label: 'Município de Origem do Imóvel concedido',
                value: (_a = dados === null || dados === void 0 ? void 0 : dados.municipioOrigem) === null || _a === void 0 ? void 0 : _a.denominacao
            }
        ];
    }, [dados === null || dados === void 0 ? void 0 : dados.denominacao, dados === null || dados === void 0 ? void 0 : dados.matricula, dados === null || dados === void 0 ? void 0 : dados.area, dados === null || dados === void 0 ? void 0 : dados.uf, (_b = dados === null || dados === void 0 ? void 0 : dados.municipioOrigem) === null || _b === void 0 ? void 0 : _b.denominacao]);
    var isNoKey = useCallback(function (obj) {
        var _a;
        return ((_a = Object.keys(obj)) === null || _a === void 0 ? void 0 : _a.length) === 0;
    }, []);
    return (_jsx(TituloCardCinza, __assign({ titulo: 'Dados Imóvel Concedido', onClick: function () { return setActiveStep === null || setActiveStep === void 0 ? void 0 : setActiveStep(1); } }, { children: _jsxs(Grid, __assign({ container: true, spacing: 2, style: { marginTop: index > 0 ? '16px' : '0' } }, { children: [_jsx(Grid, __assign({ item: true, xs: 12 }, { children: _jsx(Typography, __assign({ variant: "h6", align: "center" }, { children: "Parcela ".concat(index + 1) })) })), (_c = dadosImv()) === null || _c === void 0 ? void 0 : _c.map(function (option, index) { return (_jsx(ShowContent, __assign({ show: !isNoKey(option) }, { children: _jsx(GridView, { index: index, option: option }, "grid_field_".concat(index === null || index === void 0 ? void 0 : index.toString())) }), "field-".concat(index === null || index === void 0 ? void 0 : index.toString()))); })] })) })));
};
